import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#A8AF19",
        d: "M42.0003 11.7637h-8.9864v29.1788h8.9864z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#BFCE29",
        d: "M33.0141 7h-8.9864v33.9428h8.9864z"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#D2EF56",
        d: "M14.9864 14.5244H6v26.4179h8.9864z"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#555B00",
        d: "M9.5728 36.8282v-7.3624h1.7865v7.3624z"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#555B00",
        d: "M12.3885 29.4121H8.5991v1.4616h3.7894zm-.0008 5.9551H8.5983v1.4616h3.7894z"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#C7E036",
        d: "M23.9726 22.2666h-8.9864v18.6766h8.9864z"
    }, "5")
], "AppInsights", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
